import { Link } from "react-router-dom";

const NotFound = () => (
  <div data-testid="not-found-page" className="max-w-3xl mx-auto px-6 py-32 text-center">
    <div className="sb-mono-label">404</div>
    <h1 className="mt-2 text-5xl font-semibold text-[#1B3A5C] tracking-tight" style={{ fontFamily: "Outfit" }}>
      Page not found
    </h1>
    <p className="mt-4 text-[#64748B]">The page you're looking for doesn't exist.</p>
    <Link
      to="/"
      className="mt-8 inline-block bg-[#1B3A5C] text-white px-7 py-3 text-sm font-medium hover:bg-[#254D7A] transition-colors"
    >
      Back to home
    </Link>
  </div>
);

export default NotFound;
